<template>
  <h3>Accessibility Preferences</h3>
  <accessibility-settings/>
</template>

<script lang="ts">
import { AccessibilitySettingsVue as AccessibilitySettings } from "control-panel/control-panel.globals";
import { defineComponent } from "vue";

export default defineComponent({
  components: { AccessibilitySettings },
});
</script>
